'use strict';

angular.module('AcaApp').factory('DependentService', [
  function(){
    return {
      setMonth: function(dependent, value){
        dependent.jan = value;
        dependent.feb = value;
        dependent.mar = value;
        dependent.apr = value;
        dependent.may = value;
        dependent.jun = value;
        dependent.jul = value;
        dependent.aug = value;
        dependent.sep = value;
        dependent.oct = value;
        dependent.nov = value;
        dependent.dec = value;
      },
      allMonth: function(dependent){
        this.setMonth(dependent, dependent.all);
      },
      uncheckAll: function(dependent){
        dependent.all = false;
      },
      getindicatorRPCValue: function(value){
        return value === undefined || value === false ? '' : '1';
      },
      isAllMonthSelected: function(dependent){
        var allMonth = true;
        if(!_.isEmpty(dependent)){
          _.each(dependent, function(element){
            if(element === false){
              allMonth = false;
            }
          });
          return allMonth;
        }
      }
    };
  }
]);
